import StepBaseService from "../stepBase";
import StepBusinessType from "../stepBase/stepBusinessType";

class ApproveChangePPOStepService extends StepBaseService {
  // @ts-ignore
  getPrimaryProcedureOwnerStepKey = () => {
    return {
      dataKey: StepBusinessType.primaryProcedureOwner.dataKey,
      settingKey: "getPrimaryProcedureOwnerStepItem",
    };
  };

  // @ts-ignore
  getProcedureOwnerStepKey = () => {
    return StepBusinessType.procedureOwner;
  };

  // @ts-ignore
  getPMPExcludedStepKey = () => {
    return StepBusinessType.pmpExcluded;
  };

  // @ts-ignore
  getTaskInfoKey = () => {
    return StepBusinessType.taskInfo;
  };

  // @ts-ignore
  getFlowStepData = () => null;
}

export default new ApproveChangePPOStepService();
